import { render, staticRenderFns } from "./articleListComponent.vue?vue&type=template&id=28f82cf6&scoped=true"
import script from "./articleListComponent.vue?vue&type=script&lang=js"
export * from "./articleListComponent.vue?vue&type=script&lang=js"
import style0 from "./articleListComponent.vue?vue&type=style&index=0&id=28f82cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f82cf6",
  null
  
)

export default component.exports